<template>
	<div :key="sonlistfieldKey">
		<!-- 		<vxe-pulldown ref="sonlistfield" destroy-on-close>
			<template #default>
				<vxe-button icon="vxe-icon-arrow-down" style="margin: 0 10px;" @click="popshow">明细查询</vxe-button>
			</template>
			<template #dropdown>
				<div class="sonlistfield_container">
					<vxe-form>
						<vxe-form-item v-for="(item,index) in field" :title="item.title"
							:field="item.field" :item-render="{}" :key="index">
							<template v-if="item.props.type == 'emun'">
								<emun :name="item.props.name" v-model="item.value" placeholder="" clearable></emun>
							</template>
							<template v-if="!item.props.type" >
								<vxe-input v-model="item.value" placeholder="" clearable></vxe-input>
							</template>
						</vxe-form-item>
					</vxe-form>
				</div>
			</template>
		</vxe-pulldown> -->

		<el-popover placement="bottom-start" width="300" v-model="visible" >
			<div class="sonlistfield_container">
				<vxe-form ref="sonlistfield">
					<vxe-form-item v-for="(item,index) in field" :title="item.title" title-width="80" :field="item.field"
						:item-render="{}" :key="index">
						<template v-if="props[item.field].type == 'emun'">
							<emun :emptyoption="false" :cascader="props[item.field].cascader" :name="props[item.field].name" v-model="item.value" placeholder="" clearable></emun>
						</template>
						<template v-if="!props[item.field].type">
							<vxe-input v-model="item.value" placeholder="" clearable></vxe-input>
						</template>
					</vxe-form-item>
				</vxe-form>
			</div>
			<div style="text-align: right; margin: 10px">
				<!-- <el-button size="mini" type="" @click="cancel">取消</el-button> -->
				<el-button type="primary" size="mini" @click="visible = false">确定</el-button>
			</div>
			<el-button type="warning" slot="reference" size="mini" style="margin: 0 10px;" >明细查询</el-button>
		</el-popover>

	</div>
</template>
<style>

</style>
<style scoped>
	.sonlistfield_container {
		box-sizing: border-box;
		padding: 10px;
		width: 300px;
	}
</style>
<script>
	import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
	export default {
		props: {
			sonlistfield: {
				default: () => {
					return null
				}
			},
			formsConfig: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				sonlistfieldKey:Math.random(),
				name: null,
				field: [],
				props:{},
				visible:false
			}
		},
		created() {


		},
		mounted() {
			let field = this.sonlistfield
			let props = {}
			if (this.formsConfig) {
				field.forEach((item) => {
					props[item.field] = {}
					this.formsConfig.rule.forEach((_item) => {
						if (_item.field == ('$son_' + item.group)) {
							let exist = _item.props.fields.find((t) => {
								return t.field == item.field
							})
							if (exist) {
								props[item.field] = exist.props
							}
						}
					})
				})
			}
			this.props = props
			this.field = field
			// console.log(this.field, 'this.fieldthis.field')
			// console.log(this.formsConfig, 'this.formsConfig')
		},
		watch: {

		},
		computed: {

		},
		methods: {
			popshow() {
				this.$refs.sonlistfield.togglePanel()
			},
			submit() {

			},
			cancel(){
				
			},
			reset(){
				// console.log(this.field)
				this.field.forEach((item)=>{
					item.value = null
				})
				this.sonlistfieldKey = Math.random()
				// this.$refs.sonlistfield.reset()
			}
		},
		components: {
			emun
		},
	}
</script>